// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import getUniquePageLink, { BaseUniquePageLink } from "@store/Framework/Common/Utilities/getUniquePageLink";

const useUniquePageLink = <T extends BaseUniquePageLink>(pageLink: T) => {
    const dispatch = useAppDispatch();
    const uniqueIdsByPageType = useAppSelector(state => state.store.links.uniqueIdsByPageType);

    return getUniquePageLink(pageLink, dispatch, uniqueIdsByPageType);
};

export default useUniquePageLink;
